import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from '_common/hooks';
import { Tooltip } from '@ets/design-system';

import { useSelector } from '_common/hooks';
import {
  navigateToGroups,
  navigateToMyFiles,
  navigateToRecycle,
  navigateToShared,
  navigateToSpaces,
} from 'router/navigation';

import { viewPersonalSpaces } from 'Storage/pages/SpacesListPage/redux/spacesListPageSlice';
import { ToggleMonochrome } from '_common/components';

const Navigation = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const appLoading = useSelector((state) => state.app.loading.isOpen);
  const expanded = useSelector((state) => state.sidebar.expanded);
  const currentPage = useSelector((state) => state.app.currentPage);
  const personalSpaces = useSelector((state) => state.spaces.personals);

  const handleGoToMyFiles = () => {
    navigateToMyFiles();
  };

  const handleGoToShared = () => {
    navigateToShared();
  };

  const handleGoToSpaces = () => {
    if (personalSpaces) {
      dispatch(viewPersonalSpaces(false));
    }
    navigateToSpaces();
  };

  const handleGoToGroups = () => {
    navigateToGroups();
  };

  const handleGoToRecycle = () => {
    navigateToRecycle();
  };

  return (
    <>
      <Tooltip
        placement="right"
        visible={!expanded}
        content={expanded ? '' : intl.formatMessage({ id: 'storage.sidebar.myFiles' })}
        testId="sidebar-navigation-my-files"
      >
        <ToggleMonochrome
          iconProps={{ icon: 'folders' }}
          loading={appLoading}
          expanded={expanded}
          onClick={handleGoToMyFiles}
          isToggled={currentPage === '/storage'}
          margin="0 0 1rem 0"
          testId="sidebar-navigation-my-files-toggle"
        >
          <FormattedMessage id="storage.sidebar.myFiles" />
        </ToggleMonochrome>
      </Tooltip>
      <Tooltip
        placement="right"
        visible={!expanded}
        content={expanded ? '' : intl.formatMessage({ id: 'storage.sidebar.shared' })}
        testId="sidebar-navigation-shared"
      >
        <ToggleMonochrome
          iconProps={{ icon: 'folder-user' }}
          loading={appLoading}
          expanded={expanded}
          onClick={handleGoToShared}
          isToggled={currentPage === '/shared'}
          margin="0 0 1rem 0"
          testId="sidebar-navigation-shared-toggle"
        >
          <FormattedMessage id="storage.sidebar.shared" />
        </ToggleMonochrome>
      </Tooltip>
      <Tooltip
        placement="right"
        visible={!expanded}
        content={expanded ? '' : intl.formatMessage({ id: 'storage.sidebar.spaces' })}
        testId="sidebar-navigation-spaces"
      >
        <ToggleMonochrome
          iconProps={{ icon: 'box-archive' }}
          loading={appLoading}
          expanded={expanded}
          onClick={handleGoToSpaces}
          isToggled={currentPage === '/storage/spaces'}
          margin="0 0 1rem 0"
          testId="sidebar-navigation-spaces-toggle"
        >
          <FormattedMessage id="storage.sidebar.spaces" />
        </ToggleMonochrome>
      </Tooltip>
      <Tooltip
        placement="right"
        visible={!expanded}
        content={expanded ? '' : intl.formatMessage({ id: 'storage.sidebar.groups' })}
        testId="sidebar-navigation-groups"
      >
        <ToggleMonochrome
          iconProps={{ icon: 'users' }}
          loading={appLoading}
          expanded={expanded}
          onClick={handleGoToGroups}
          isToggled={currentPage === '/groups'}
          margin="0 0 1rem 0"
          testId="sidebar-navigation-groups-toggle"
        >
          <FormattedMessage id="storage.sidebar.groups" />
        </ToggleMonochrome>
      </Tooltip>
      <Tooltip
        placement="right"
        visible={!expanded}
        content={expanded ? '' : intl.formatMessage({ id: 'storage.sidebar.recycleBin' })}
        testId="sidebar-navigation-recycle"
      >
        <ToggleMonochrome
          loading={appLoading}
          expanded={expanded}
          iconProps={{ icon: 'trash' }}
          onClick={handleGoToRecycle}
          isToggled={currentPage === '/storage/recycle'}
          margin="0 0 1rem 0"
          testId="sidebar-navigation-recycle-toggle"
        >
          <FormattedMessage id="storage.sidebar.recycleBin" />
        </ToggleMonochrome>
      </Tooltip>
    </>
  );
};
export default Navigation;
